<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs"/>
    </div>
    <div class="form-npa law-edit">
      <div class="position">
        <div class="bg-white p-20">
          <form action="">
            <div class="form-body">
              <table class="table">
                <tbody>
                <tr>
                  <td colspan="2">
                    <div class="form-group">
                      <p>{{ $t("Закон") }} {{ lawDeveloper.law_name }}</p>
                      <p>{{ $t("Мыйзамы") }} {{ lawDeveloper.law_nameKg }}</p>
                      <p>{{ $t("Дата") }}, №{{ lawDeveloper.law_number }} {{$t("от")}}
                        {{ new Date(lawDeveloper.law_adoption_date)
                        | dateFormat('DD.MM.YYYY') }}
                      </p>
                      <p>{{ $t("Дата вступления") }} {{ new Date(lawDeveloper.law_effective_date)
                        | dateFormat('DD.MM.YYYY') }}
                      </p>
                    </div>
                    <div class="form-group">
                      <label>{{ $t("Требует ли проведение решений госоргана в соответствии с Законом?") }}</label>
                      <div>
                        <v-radio-group v-model="solveNeeded">
                          <v-radio
                            :label="$t('да')"
                            v-bind:value="true"
                            rounded
                            :checked="solveNeeded === true"
                          ></v-radio>
                          <v-radio
                            :label="$t('нет')"
                            v-bind:value="false"
                            rounded
                            :checked="solveNeeded === false"
                          ></v-radio>
                        </v-radio-group>
                      </div>
                    </div>
                    <div class="table-overflow"
                         v-if="(solveNeeded === true || solveNeeded === false) && lawProjects.length > 0">
                      <table>
                        <thead>
                        <tr>
                          <td>{{ $t("Наименование") }}</td>
                          <td>{{ $t("Стадия") }}</td>
                          <td>{{ $t("Примечание") }}</td>
                          <td class="td-action">{{ $t("Действие") }}</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="lawProject in lawProjects" :key="lawProject.id">
                          <td>
                            <template v-if="lawProject.npaId">
                              <router-link
                                :title="lawProject.name | strippedContent"
                                :to="$i18nRoute({name: 'view-npa', params: { id: lawProject.npaId }})"
                                target="_blank"
                              >
                                {{ lawProject.name }}
                              </router-link>
                            </template>
                            <template v-else>
                              {{ lawProject.name }}
                            </template>
                          </td>
                          <td>
                            <div class="stage">
                              <template v-if="!lawProject.edit">
                                {{ lawProject.stageName }}
                                <div v-if="!lawProject.npaId">
                                  <SetNpa
                                    :npas="npas"
                                    :lawProjectId="lawProject.id"
                                  />
                                </div>
                              </template>
                              <template v-else>
                                <div class="form-group">
                                  <v-select
                                    v-model="lawProject.stageId"
                                    :items="stages"
                                    item-text="transName"
                                    item-value="id"
                                    @change="onChange(lawProject.id)"
                                    outlined
                                    dense
                                  />
                                </div>
                              </template>
                              <a
                                v-if="lawProject.npaId && !lawProject.edit"
                                @click="lawProject.edit = true"
                                class="edit-btn"
                              >
                                <span class="pro-icon-pencil"></span>
                              </a>
                            </div>
                          </td>
                          <td>
                            {{ lawProject.note }}
                          </td>
                          <td class="td-action">
                            <span class="pro-icon-close" @click="deleteLawProject(lawProject.id)"></span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <NpaProject
                      :solveNeeded="solveNeeded"
                    />
                    <div class="form-group form-action" v-if="solveNeeded === true || solveNeeded === false">
                      <button
                        class="btn btn-default blue"
                        @click.prevent="setSolveNeeded"
                      >
                        {{ $t("Сохранить") }}
                      </button>
                      <button
                        class="btn btn-default white"
                        @click.prevent="onCancel"
                      >
                        {{ $t("Отмена") }}
                      </button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import {mapMutations} from 'vuex'
  import NpaProject from '@/components/law/NpaProject'
  import SetNpa from '@/components/law/SetNpa'
  import LAW from '@/model/law'
  import {Trans} from "@/plugins/Translation"

  export default {
    components: {
      NpaProject,
      SetNpa
    },
    mounted() {
      this.fetchData()
      this.scrollToTop()
    },
    data() {
      return {
        solveNeeded: null,
        breadcrumbs: [],
        lawDeveloper: {},
        lawProjects: [],
        stages: [],
        npas: [],
      }
    },
    methods: {
      ...mapMutations(['setLoading']),
      fetchData(updateSolve = true) {
        this.setLoading(true)
        LAW.getLawDeveloperInfo(this.$route.params.id).then((response) => {
          this.lawDeveloper = response.data.lawDeveloper
          if (updateSolve) {
            this.solveNeeded = this.lawDeveloper.solve_needed
          }
          this.lawProjects = response.data.lawProjects
          this.lawProjects.forEach(l => this.$set(l, 'edit', false))
          this.stages = response.data.stages
          this.npas = response.data.npas
          this.generateBreadcrumbs(this.lawDeveloper.name)
          this.setLoading(false)
        }).catch((error) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
          this.setLoading(false)
        })
      },
      // генерация хлебных крошек
      generateBreadcrumbs(name) {
        this.breadcrumbs = [
          {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
          {text: this.$i18n.t('Исполнение законов'), disabled: false, href: Trans.currentLocaleUrl + '/law'},
          {text: name, disabled: true}
        ]
      },
      // удаление Проекта
      deleteLawProject(id) {
        if (!confirm(this.$i18n.t('Вы действительно хотите удалить проект НПА?'))) {
          return
        }
        LAW.deleteLawProject(id).then((response) => {
          if (response.status === 200) this.fetchData()
        }).catch((error) => {
          console.log(error)
        })
      },
      setSolveNeeded() {
        if (this.solveNeeded === false && this.lawProjects.length > 0) {
          this.$noty.warning(this.$i18n.t('Значение поля \'Требует ли проведение решений\' не может быть в \'нет\', если добавлены проекты'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
          return
        }
        LAW.setSolveNeeded(this.$route.params.id, this.solveNeeded).then((response) => {
          if (response.status === 200) this.onCancel()
        })
      },
      onChange(projectId) {
        const lawProject = this.lawProjects.find(l => l.id === projectId)
        lawProject.edit = false
        if (!confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
          return
        }
        LAW.changeStage(projectId, lawProject.stageId).then((response) => {
          if (response.status === 200) {
            this.fetchData()
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // Отмена
      onCancel() {
        this.$router.push(Trans.i18nRoute({name: 'law'}))
      },
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>

<style scoped></style>
